import useActiveTenantRole from 'src/hooks/useActiveTenantRole';
import RefreshHome from './components/RefreshHome';

const DashboardGrid = () => {
  const { isGuest } = useActiveTenantRole();
  return <RefreshHome disableChat={isGuest} />;
};

export default DashboardGrid;
